import {Link, NavLink, Outlet} from "react-router";
import {Archive, ArrowLeft, BookText, LayoutDashboard, ShieldCheck, Users} from "lucide-react";
import direDawnIcon from "@assets/diredawn_icon.png";
import UserMenu from "@/auth/UserMenu.tsx";
import {cn} from "@/lib/utils.ts";

const navigation = [
    {title: "Übersicht", to: "/admin", icon: LayoutDashboard, end: true},
    {title: "Kampagnen", to: "/admin/campaigns", icon: BookText, end: false},
    {title: "Benutzer", to: "/admin/users", icon: Users, end: false},
    {title: "Backups", to: "/admin/backups", icon: Archive, end: false},
];

export default function AdminLayout() {
    return <div className="flex h-full min-h-0 flex-col bg-background">
        <header className="flex h-12 shrink-0 items-center gap-3 border-b border-border bg-surface/85 px-2 shadow-lg shadow-black/10 backdrop-blur-xl">
            <Link to="/" className="flex items-center gap-2 px-2" title="Zur Kampagnenauswahl">
                <img src={direDawnIcon} className="size-7" alt="DireDawn"/>
                <span className="font-semibold tracking-wide">DireDawn</span>
            </Link>
            <span className="h-6 border-l border-border"/>
            <span className="flex items-center gap-2 text-sm font-semibold text-secondary-foreground">
                <ShieldCheck className="size-4"/>Administration
            </span>
            <div className="grow"/>
            <UserMenu/>
        </header>
        <div className="flex min-h-0 grow">
            <aside className="flex w-60 shrink-0 flex-col border-r border-border bg-sidebar/90 p-3">
                <nav className="space-y-1" aria-label="Administration">
                    {navigation.map(item => <NavLink key={item.to} to={item.to} end={item.end}
                        className={({isActive}) => cn(
                            "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground",
                            isActive && "bg-secondary/25 text-foreground shadow-sm ring-1 ring-secondary/30"
                        )}>
                        <item.icon className="size-4"/>{item.title}
                    </NavLink>)}
                </nav>
                <div className="grow"/>
                <Link to="/" className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-muted-foreground hover:bg-accent hover:text-foreground">
                    <ArrowLeft className="size-4"/>Kampagnen
                </Link>
            </aside>
            <section className="min-w-0 grow overflow-auto"><Outlet/></section>
        </div>
    </div>;
}
